// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ErrorMessage_errorMessage__c5U6r"};